import { useInView } from '../hooks/useInView.js'

/**
 * Reveals its children with a soft fade + rise when scrolled into view.
 * `delay` (ms) lets you stagger siblings.
 */
export default function Reveal({ children, delay = 0, y = 24, className = '', style = {} }) {
  const { ref, inView } = useInView()
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'none' : `translateY(${y}px)`,
        transition: `opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms, transform 0.7s cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms`,
        willChange: 'opacity, transform',
        ...style,
      }}
    >
      {children}
    </div>
  )
}
